module.exports = __webpack_public_path__ + "img/guide_2.b7306daf.png";